import { $policyApi } from '../../index';
import { AxiosResponse } from 'axios';
import { PolicyResponse, PolicyPayload } from './types';

export default class Policy {
	static async issue(data: PolicyPayload): Promise<AxiosResponse<PolicyResponse>> {
		return $policyApi.post(``, data)
	}
}
